<template>
    <div class="home" v-on:scroll="onScroll" :class="[inapp? 'inapp' : '', !scrolled ? '-scrolled': '']">
        <span id="top"></span>

        <div class="sticky" :class="!$googleplay && !$appstore ? '': ''">
          <a :href="$appstore" :class="!$appstore ? 'sticky__disabled': ''">
            <img src="/img/icon-appstore.png" alt="icon fb">
          </a>
          <a :href="$googleplay" :class="!$googleplay ? 'sticky__disabled': ''">
            <img src="/img/icon-googleplay.png" alt="icon fb">
          </a>
        </div>

        <Nav :scrollcount.sync="scrollval" v-on:childToParent="onChildClick"></Nav>

        <div class="docs docs__container -larger" :class="opennav ? 'open': ''">
            <p class="docs__title">Healthcare Customers’ Frequently Asked Questions</p>
            <div class="docs docs__faq">
                <v-toolbar flat>
                  <v-toolbar-title>Categories:</v-toolbar-title>
                </v-toolbar>

                <v-tabs
                  vertical
                  hide-slider
                  :value="currentTab"
                >
                  <v-tab
                    left
                    v-for="(item, tabId) in faq"
                    :key="tabId"
                    :class="item.child ? '-child' : item.parent ? '-parent' : ''"
                    :href="(item.href) ? `#${item.href}` : `#${tabId}`"
                  >
                    {{ item.tab }}
                  </v-tab>

                  <v-tab-item
                    v-for="(item, tabId) in faq"
                    :key="tabId"
                    :id="tabId"
                  >
                    <v-expansion-panels
                      accordion
                      :value="(currentTab === tabId) ? openedArticle : 0"
                    >
                      <v-expansion-panel
                        v-for="(info, articleId) in item.contents"
                        :key="articleId"
                      >
                        <v-expansion-panel-header
                          :hide-actions="true"
                          :class="info.img ? '-w-img' : ''"
                          @click="logReadingThis(info.title)"
                        >
                          {{ info.title }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="faq-content">
                            <img v-if="info.fullImg" class="cont-img" :src="'/img/faq/' + info.fullImg">
                            <a
                              v-if="info.fullImg && info.media"
                              class="file-link" target="_blank"
                              :href="'/' + info.media"
                            >See full details</a>

                            <p v-if="info.desc" class="faq-desc" v-html="info.desc"></p>

                            <template v-if="info.list">
                              <ListDescription :listDesc="info.list"></ListDescription>
                            </template>

                            <template v-if="info.multiList">
                              <NestedListDescription :multiListDesc="info.multiList"></NestedListDescription>
                            </template>

                            <template v-if="info.multiDesc">
                              <p class="faq-desc" v-for="(desc, multiId) in info.multiDesc" :key="multiId" v-html="desc"></p>
                            </template>

                            <div class="article-functions">
                              <SocialShare
                                :faqArticle="info"
                                :articleDir="{
                                  tab: tabId,
                                  article: articleId
                                }"
                              ></SocialShare>
                              <RateArticle
                                :faqArticle="info"
                                :articleId="articleId"
                              ></RateArticle>
                            </div>
                          </div>
                          <div v-if="info.img" class="faq-image">
                            <img class="cont-img" :src="'/img/faq/desktop/' + info.img">
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-tab-item>
                </v-tabs>
            </div>

            <div class="docs docs__faq -mobile">
                <div class="faq-categories">

                    <div
                      :class="item.child ? 'category-section -child' : item.parent ? 'category-section -parent' : 'category-section'"
                      v-for="(item, tabId) in faq"
                      :key="tabId"
                      :style="item.style"
                    >
                      <v-img
                        v-if="item.preview"
                        class="preview"
                        max-width="240"
                        :src="'/img/faq/mobile/' + item.preview"
                      ></v-img>
                      <v-img
                        v-if="item.fullPreview"
                        class="full-preview"
                        :src="'/img/faq/mobile/' + item.fullPreview"
                      ></v-img>
                      <h2
                        class="title"
                        v-if="!item.child"
                      >{{ item.tab }}:</h2>

                      <template v-if="item.child">
                        <v-expansion-panels accordion>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              :hide-actions="true"
                            >
                              <h2 class="title">{{ item.tab }}</h2>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>

                              <div class="article-title"
                                v-for="(info, articleId) in item.contents"
                                :key="articleId"
                                @click="!info.media? openModal(info, [tabId, articleId]) : {}"
                              >
                                <template v-if="!info.media">{{ info.title }}</template>
                                <a
                                  v-if="info.media"
                                  target="_blank"
                                  :href="'/' + info.media"
                                >{{ info.title }}</a>
                              </div>

                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </template>

                      <template v-else>
                        <div class="article-title"
                          v-for="(info, articleId) in item.contents"
                          :key="articleId"
                          @click="!info.media? openModal(info, [tabId, articleId]) : {}"
                        >
                          <template v-if="!info.media">{{ info.title }}</template>
                          <a
                            v-if="info.media"
                            target="_blank"
                            :href="'/' + info.media"
                          >{{ info.title }}</a>
                        </div>
                      </template>
                    </div>
                </div>
                <ArticleModal
                  :status="modal"
                  :article="modalData"
                  :directory="modalDirectory"
                  @modal-close="updateModal"
                ></ArticleModal>
            </div>
        </div>

        <FooterHome></FooterHome>
        <v-btn
          v-scroll="onScroll"
          v-show="toTop"
          fab
          fixed
          bottom
          right
          depressed
          color="#8E70D4"
          @click="scrollToTop"
          class="to-top"
        >
          <v-img max-width="18" src="/img/icons/to-top.svg"></v-img>
        </v-btn>

    </div>
</template>
<script>
import axios from 'axios';
import firebase from 'firebase/app';
import Nav from '../../components/Nav.vue';
import ListDescription from '../../components/ListDescription.vue';
import NestedListDescription from '../../components/NestedListDescription.vue';
import SocialShare from '../../components/SocialShare.vue';
import RateArticle from '../../components/RateArticle.vue';
import ArticleModal from '../../components/ArticleModal.vue';
import FooterHome from '../../components/FooterHome.vue';
import faqjson from '../../../public/files/faq.json';
import 'firebase/analytics';

export default {
  data() {
    return {
      scrollval: 0,
      panel: [],
      faq: '',
      inapp: false,
      opennav: false,
      currentTab: '',
      openedArticle: 0,
      modal: false,
      modalData: {},
      modalDirectory: [],
      toTop: false,
      scrolled: false,
    };
  },
  mounted() {
    this.setFaq();

    const routeParams = this.$route.params;
    const { tabId } = routeParams;
    const { articleId } = routeParams;

    if (tabId) this.currentTab = tabId;
    if (articleId) this.openedArticle = Number(articleId);
  },
  components: {
    Nav,
    FooterHome,
    ListDescription,
    NestedListDescription,
    SocialShare,
    RateArticle,
    ArticleModal,
  },
  methods: {
    setFaq() {
      axios.get('/files/faq.json').then((response) => {
        let stringified = JSON.stringify(response.data);
        stringified = stringified.replace(/%LINK%/g, this.$contact);
        stringified = stringified.replace(/%ANDRIOD%/g, this.$googleplay);
        stringified = stringified.replace(/%IOS%/g, this.$appstore);
        this.faq = JSON.parse(stringified);

        if (this.$vuetify.breakpoint.xsOnly) {
          this.initModal();
        }

        if (this.$route.query.id) {
          this.inapp = true;
          this.all();
        } else {
          this.none();
        }
      });
    },
    all() {
      this.panel = [...Array(this.faq.length).keys()].map((k, i) => i);
    },
    // Reset the panel
    none() {
      this.panel = [0];
    },
    onChildClick(value) {
      this.opennav = value;
    },
    onScroll(element) {
      const el = document.querySelector('div.home');
      // const elheader = document.querySelector('.header');
      this.scrollval = el.scrollTop;

      this.scrolled = true;
      if (el.scrollTop !== 0) {
        this.scrolled = false;
      }

      // to top element
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || element.target.scrollTop || 0;
      this.toTop = top > 20;
    },
    logReadingThis(articleTitle) {
      firebase.analytics().logEvent('faq_read', {
        article: articleTitle,
      });
    },
    openModal(modalData, directory) {
      this.modal = true;
      this.modalData = modalData;
      this.modalDirectory = directory;
    },
    updateModal(status) {
      this.modal = status;
    },
    initModal() {
      const routeParams = this.$route.params;
      const { tabId } = routeParams;
      const { articleId } = routeParams;

      if (!tabId || !articleId) return;
      if (!this.faq[tabId]) return;

      const { contents } = this.faq[tabId];

      if (!contents[articleId]) return;

      const article = contents[articleId];

      this.openModal(article, [tabId, articleId]);
    },
    scrollToTop() {
      const elContainer = document.querySelector('div.home');

      this.$vuetify.goTo('#top', { container: elContainer });
    },
  },
};
</script>
